//
// **NOTE**: Do not edit directly! This file is generated using `npm run import-typescript`
//
export var typescriptVersion = "4.0.3";
